export default "__VITE_ASSET__DuhyUrnn__"